export enum ScheduleTypeEnum {
	ClassSchedule = "classSchedule",
	StudentSchedule = "studentSchedule"
}
